import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { DeleteConfirmationComponent } from "./delete-confirmation.component";
import { DeleteConfirmationService } from "./delete-confirmation.service";

@NgModule({
    imports: [CommonModule, MatDialogModule, MatButtonModule, MatFormFieldModule, MatInputModule, FormsModule],
    declarations: [DeleteConfirmationComponent],
    exports: [DeleteConfirmationComponent],
    providers: [DeleteConfirmationService],
})
export class DeleteConfirmationModule {}
